import ProductPage from './ProductPage';

const features = [
  { heading: 'Built for your business', text: 'Staff sign in, mark in/out and request leave from their own phone — no need to wait for HR.', icon: '👤' },
  { heading: 'Save time every day', text: 'Instant access to monthly payslips, salary breakdowns and advance balances.', icon: '⏱' },
  { heading: 'Secure and reliable', text: 'Multi-language support so every team member uses the app in the language they are comfortable with.', icon: '🔒' },
];

export default function StaffApp() {
  return (
    <ProductPage
      title="Staff App"
      subtitle="Your staff can mark attendance and access salary slips at their fingertips."
      features={features}
      ctaTitle="Staff App"
    />
  );
}
